module.exports = __webpack_public_path__ + "static/img/previous-page.120382c8.svg";